module.exports = __webpack_public_path__ + "static/media/background-chat.7df0c293.png";